// extracted by mini-css-extract-plugin
export var sbShowMain = "paginationDynamic-module--sb-show-main--3g78M";
export var pagination = "paginationDynamic-module--pagination--vrCAC";
export var paginationInner = "paginationDynamic-module--paginationInner--2Mt0M";
export var disabled = "paginationDynamic-module--disabled--1z_DW";
export var current = "paginationDynamic-module--current--l1BOu";
export var next = "paginationDynamic-module--next--3Jw9R";
export var prev = "paginationDynamic-module--prev--X7kTO";
export var dots = "paginationDynamic-module--dots--3kEFa";